import { render, staticRenderFns } from "./SpaceIndicator.vue?vue&type=template&id=10e2b64b&scoped=true&"
import script from "./SpaceIndicator.vue?vue&type=script&lang=js&"
export * from "./SpaceIndicator.vue?vue&type=script&lang=js&"
import style0 from "./SpaceIndicator.vue?vue&type=style&index=0&id=10e2b64b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2b64b",
  null
  
)

export default component.exports